import { graphql, useStaticQuery } from 'gatsby';
import gql from 'graphql-tag';
import React, { FC, useState } from 'react';
import { useMutation } from 'urql';

import {
  Card,
  CardCloseButton,
  CardOptions,
  ErrorMessage,
  Form,
  SubmitButton,
  useModalContext,
} from '@/components';
import { useTranslate } from '@/contexts';
import { useIsMounted } from '@/hooks';
import { Nullable } from '@/types';
import { PlayerForfeitActiveBonusMutation } from './__generated__/PlayerForfeitActiveBonusForm';

const query = graphql`
  query SanityPlayerForfeitActiveBonusForm {
    sanityPlayerForfeitActiveBonusForm {
      title {
        ...SanityLocaleString
      }
      description {
        ...SanityLocaleString
      }
      submit {
        ...SanityLocaleString
      }
    }
  }
`;

const playerMutation = gql`
  mutation PlayerForfeitActiveBonus($playerId: ID!) {
    forfeitBonus(playerId: $playerId)
  }
`;

const PlayerForfeitActiveBonusForm: FC<{ playerId: string }> = ({
  playerId,
}) => {
  const staticData =
    useStaticQuery<Queries.SanityPlayerForfeitActiveBonusFormQuery>(query);

  const [errorMessage, setErrorMessage] = useState<Nullable<string>>(null);
  const isMounted = useIsMounted();

  const form = staticData.sanityPlayerForfeitActiveBonusForm;

  const [playerForfeitActiveBonusState, playerForfeitActiveBonus] =
    useMutation<PlayerForfeitActiveBonusMutation>(playerMutation);

  const { close } = useModalContext();

  const { t } = useTranslate();

  const onSubmit = () => {
    playerForfeitActiveBonus({
      playerId,
    }).then((res) => {
      if (res.error?.message && isMounted) {
        setErrorMessage(res.error.message);
      } else if (close) {
        close();
      }
    });
  };

  if (!form) {
    return null;
  }
  return (
    <Card
      size="lg"
      title={t(form.title)}
      options={
        <CardOptions>
          <CardCloseButton />
        </CardOptions>
      }
    >
      <div className="p-3">
        <Form defaultValues={{}} onSubmit={onSubmit} className="grid gap-6">
          <div className="text-black dark:text-white">
            {t(form.description)}
          </div>
          <ErrorMessage message={errorMessage} />
          <SubmitButton
            value={t(form.submit)}
            disabled={playerForfeitActiveBonusState.fetching}
          />
        </Form>
      </div>
    </Card>
  );
};

export default PlayerForfeitActiveBonusForm;
